
import sha256 from 'js-sha256';
import { mapGetters, mapActions } from 'vuex';
import { Dialog, Scrollbar, Tooltip } from 'element-ui';
import { cloneDeep } from 'lodash';
import { exchangeMember, createOrder, addAdress } from '~/api/index';
import pageCoupon from '~/components/member/order-dialog/coupon.vue';
import pagePay from '~/components/member/order-dialog/pay.vue';
import pageSuccess from '~/components/member/order-dialog/success.vue';
import pageAddress from '~/components/member/order-dialog/address.vue';
import pageAttestation from '~/components/member/order-dialog/attestation.vue';
import assetAllocation from '~/components/member/order-dialog/AssetAllocation.vue';
export default {
  components: {
    ElScrollbar: Scrollbar,
    ElDialog: Dialog,
    ElTooltip: Tooltip,
    pageCoupon,
    pagePay,
    pageSuccess,
    pageAddress,
    pageAttestation,
    assetAllocation,
  },
  data() {
    return {
      page: 'index',
      selectCoupon: '',
      orderDetail: null,
      toast: {
        show: false,
        text: '',
        icon: '',
        timer: null,
        desc: '',
      },
      attestationValue: 0,
      attestationShow: false,
      attestationId: null,
    };
  },
  computed: {
    ...mapGetters('user', ['avatar', 'nickname', 'kyc']),
    ...mapGetters({
      show: 'order/dialogShow',
      specsId: 'order/specsId',
      data: 'order/dialogData',
      info: 'order/info',
      userCoin: 'order/userCoin',
    }),
    /**
     * @description 格式化数据
     * @returns { Object } 格式化后的数据
     */
    formatData() {
      const obj = {
        article: null,
        column: null,
        vip: null,
        permanent: null,
        singleVideo: null,
        pack: null,
      };
      if (this.data && this.data.goods) {
        for (const item of this.data.goods) {
          const data = cloneDeep(item);
          obj[item.type] = data;
        }
      }
      return obj;
    },
    /**
     * @description 判断是否开通会员
     * @returns { Boolean } 判断结果
     */
    isMember() {
      let list =
        (this.formatData.permanent &&
          this.formatData.permanent.purchaseInfos) ||
        [];
      list = list.filter(item => item.specsId === this.specsId);
      return (
        list.length > 0 && (!list[0].name || list[0].name.includes('会员'))
      );
    },
    formatAddress() {
      return cloneDeep(this.info.address);
    },
  },
  watch: {
    show(val) {
      if (!val) {
        this.page = 'index';
        this.selectCoupon = '';
        this.orderDetail = null;
      }
      this.getUserKyc();
    },
  },
  methods: {
    ...mapActions({
      updateShowStatus: 'order/updateShowStatus',
      updateSpecsId: 'order/updateSpecsId',
      updateInfo: 'order/updateInfo',
      dialogClose: 'order/closeDialog',
      getGoodsPayment: 'order/getGoodsPayment',
      getAddress: 'order/getAddress',
      createMemberOrder: 'order/createOrder',
      updateCoin: 'order/updateCoin',
      getUserKyc: 'getUserKyc',
    }),
    /**
     * @description 展示操作提示
     * @param { Object } 操作对象
     * @param { Number } 相应间隔
     */
    showToast(obj, time = 3000) {
      clearTimeout(this.toast.timer);
      this.toast = Object.assign(this.toast, obj);
      this.toast.timer = setTimeout(() => {
        this.cannelToast();
      }, time);
    },
    /**
     * @description 取消操作提示
     */
    cannelToast() {
      clearTimeout(this.toast.timer);
      this.toast = {
        show: false,
        text: '',
        icon: '',
        timer: null,
        desc: '',
      };
    },
    /**
     * @description 关闭弹窗
     */
    closeDialog() {
      this.attestationValue = 0;
      this.attestationShow = false;
      this.dialogClose();
      if (this.page === 'success') {
        location.reload();
      }
    },
    /**
     * @description 修改选中商品
     * @param { Number } item 操作对象
     */
    changeGood(item) {
      const obj = {};
      obj.memberPrice = item.price;
      obj.couponList = item.coupons || [];
      obj.chooseCoupon = '';
      obj.vipDiscount = item.vipDiscount;
      obj.displayButtonText = item.displayButtonText;
      obj.paymethod = 'wechat';
      obj.memberSpecsId = null;
      if (obj.couponList.length > 0) {
        // 如果存在优惠券则选择第一个优惠券
        obj.chooseCoupon = Object.assign({}, obj.couponList[0]);
      }
      this.updateInfo(obj);
      this.updateSpecsId(item.specsId);
      this.getGoodsPayment();
    },
    /**
     * @description 是否选择会员
     * @param { number } val 会员id
     */
    async changeMember(val) {
      const obj = {};
      obj.memberSpecsId = this.info.memberSpecsId ? null : val;
      this.updateInfo(obj);
      const message = await this.getGoodsPayment();
      if (message) {
        this.showToast(
          {
            show: true,
            text: message,
            icon: 'g-icon-error',
          },
          5000
        );
      }
    },
    /**
     * @description 修改支付方式
     * @param { string } val 支付方式
     */
    changePaymethod(val) {
      if (val === 'gurucoin' && this.info.payInfo.total > this.userCoin) {
        this.showToast(
          {
            show: true,
            text: '抱歉，格隆贝余额不足，无法完成付款',
            icon: 'g-icon-error',
            desc: '可通过格隆汇APP充值格隆贝，如有疑问，请联系客服Guruclub_88',
          },
          5000
        );
      } else {
        this.updateInfo({
          paymethod: val,
        });
      }
    },
    /**
     *  @description 格式化连接
     */
    formatLink(link) {
      let val = link.split('/');
      val = val[val.length - 1];
      return `/album/${val}`;
    },
    /**
     * @description 判断当前父项是否选中
     */
    isActive(type) {
      if (this.formatData[type] && this.formatData[type].purchaseInfos) {
        for (const item of this.formatData[type].purchaseInfos) {
          if (item.specsId === this.specsId) return true;
        }
      }
      return false;
    },
    isCouponIcon(type) {
      if (this.formatData[type] && this.formatData[type].purchaseInfos) {
        for (const item of this.formatData[type].purchaseInfos) {
          if (item.coupons && item.coupons.length > 0) return true;
        }
      }
      return false;
    },
    openMemberOrder(specsId) {
      this.createMemberOrder({
        specsId,
      });
    },
    /**
     * @description 修改弹窗展示页面
     */
    changePage(val) {
      if (val === 'coupon' && this.info.chooseCoupon) {
        this.selectCoupon = Object.assign({}, this.info.chooseCoupon);
      }
      this.page = val;
    },
    /**
     * @description 修改地址
     */
    editAdress() {
      this.changePage('address');
    },
    /**
     * @description 地址按钮点击
     */
    async addressClick(obj) {
      if (obj.type === 'submit') {
        const data = await this.$axios(
          addAdress({
            name: obj.form.name,
            countryCode: '86',
            phoneNum: obj.form.phone,
            country: '中国',
            state: obj.form.temp.state,
            city: obj.form.temp.city,
            address:
              obj.form.address.indexOf(obj.form.temp.dist) === 0
                ? obj.form.address
                : obj.form.temp.dist + obj.form.address,
          })
        );
        if (data.statusCode === 200) {
          this.getAddress();
        }
      }
      this.changePage('index');
    },
    /**
     * @description 选择优惠券
     */
    changeCoupon() {
      const obj = {};
      if (this.selectCoupon) {
        obj.chooseCoupon = Object.assign({}, this.selectCoupon);
      } else {
        obj.chooseCoupon = '';
      }
      this.updateInfo(obj);
      this.getGoodsPayment(false);
      this.selectCoupon = '';
      this.changePage('index');
    },
    openMemberPage() {
      window.open('/user/member');
    },
    /**
     * @description 生成订单
     */
    async createOrder() {
      if (!this.kyc.certification || !this.kyc.svipInvestor) {
        this.attestationShow = true;
        return false;
      }
      if (this.info.payInfo.total === 0 || this.info.paymethod === 'gurucoin') {
        // 格隆贝支付
        if (this.info.payInfo.total > this.userCoin) {
          this.showToast(
            {
              show: true,
              text: '抱歉，格隆贝余额不足，无法完成付款',
              icon: 'g-icon-error',
              desc: '可通过格隆汇APP充值格隆贝，如有疑问，请联系客服Guruclub_88',
            },
            5000
          );
          return false;
        }
        const data = await this.$axios(
          exchangeMember(
            this.info.payInfo.packageSpecsId,
            this.info.chooseCoupon.couponId || ''
          )
        );
        if (data.statusCode === 200) {
          this.changePage('success');
        }
        return false;
      } else {
        // 微信支付
        await this.getPaymentCode();
        this.changePage('pay');
      }
    },
    /**
     * @description 接口请求支付二维码
     */
    async getPaymentCode() {
      const goodsId = this.info.payInfo.packageSpecsId;
      const channel = 'wx_pub_qr';
      const platform = 'web';
      const { publicKey, userToken } = this.info;
      // console.log(goodsId, channel, platform, publicKey, userToken);
      const sign = sha256(
        sha256(`${goodsId}${channel}${platform}`) + publicKey + userToken
      );
      const res = await this.$axios(
        createOrder({
          goodsId: String(goodsId),
          channel,
          sign,
          couponId: this.info.chooseCoupon.couponId || '',
        })
      );
      if (res.statusCode === 200) {
        const codeUrl = res.result.data.codeUrl;
        const orderNo = res.result.id;
        const amount = res.result.amount;
        this.orderDetail = {
          codeUrl,
          orderNo,
          amount,
        };
      } else {
        // eslint-disable-next-line no-console
        console.log('生成订单失败');
        return false;
      }
    },
  },
};
